import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../store';

export { useDebriefApp } from './useDebriefApp';
export { useCurrentTracklog } from './useCurrentTracklog';
export { useCurrentDebrief } from './useCurrentDebrief';
export { useCurrentLogbook } from './useCurrentLogbook';
export { useMapControls } from './useMapControls';
export { useChrono } from './useChrono';
export { useMapSettings } from './useMapSettings';
export { useDebriefRouter } from './useDebriefRouter';
export { useCurrentAircraft } from './useCurrentAircraft';
export { useDebriefSegments } from './useDebriefSegments';
export { useDebriefStatus } from './useDebriefStatus';
export { useAnalytics } from './useAnalytics';
export { useSyncSettings } from './useSyncSettings';
export { useFlightDataDirectory } from './useFlightDataDirectory';
export { useRouteContext } from './useRouteContext';

export const useDebriefSelector: TypedUseSelectorHook<RootState> = useSelector;
export const useDebriefDispatch = () => useDispatch<AppDispatch>();
